"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

require("./_icons.scss");

var SvgIcon = function SvgIcon(_ref) {
  var children = _ref.children,
      style = _ref.style,
      viewBox = _ref.viewBox,
      className = _ref.className,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["children", "style", "viewBox", "className"]);
  return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg"
  }, other, {
    className: className,
    viewBox: viewBox
  }), children);
};

SvgIcon.defaultProps = {
  viewBox: "0 0 24 24",
  preserveAspectRatio: "xMidYMid meet"
};
var _default = SvgIcon;
exports["default"] = _default;